import { render } from "./WhitepaperContact.vue?vue&type=template&id=2e115f42&scoped=true"
const script = {}

import "./WhitepaperContact.vue?vue&type=style&index=0&id=2e115f42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e115f42"]])

export default __exports__